// Added by Sejune Oh on 2020-02-28
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { FC } from 'react'
import {
    Typography as MaterialTypography,
    TypographyProps as MaterialTypographyProps,
} from '@/components/_primes/v2'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
const Typography:FC<MaterialTypographyProps> = ({...props}) => {
    return <MaterialTypography {...props}></MaterialTypography>
}

export default Typography
